import * as _ from "lodash";
import Swal from "sweetalert2";
import * as yup from "yup";
import { ko } from "yup-locales";
import { toast } from "vue-sonner";
import { validateMessage } from '@/const';

export default defineNuxtPlugin((nuxtApp) => {
  // 지역 설정
  yup.setLocale(ko);

  // custom validate
  yup.addMethod(yup.string, "phone", function (errorMessage) {
    return this.test(`test-phone`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value == null || value === 0 || !value.trim()) {
        return true;
      }
      const regPhone = /^(0[2-8][0-5]?)([1-9]{1}[0-9]{2,3})([0-9]{4})$/;
      return regPhone.test(value) ? true : createError({ path, message: errorMessage });
    });
  });

  yup.addMethod(yup.string, "mobile", function (errorMessage) {
    return this.test(`test-mobile`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value == null || value === 0 || !value.trim()) {
        return true;
      }
      const regex = /^0\d{1,2}-\d{3,4}-\d{4}$/;
      return regex.test(value) ? true : createError({ message: validateMessage.mobile });
    });
  });

  yup.addMethod(yup.string, "password", function (errorMessage) {
    return this.test(`test-password`, errorMessage, function (value : string | undefined) {
      const { path, createError } = this;
      if(value == null || !value.trim()) {
        return createError({ message: validateMessage.password });
      }
      const regex = /^[a-zA-Z0-9#?!@$%^&*-](?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-])[a-zA-Z0-9#?!@$%^&*-]{7,15}$/;
      return regex.test(value) ? true : createError({ message: validateMessage.password });
    });  
  });

  yup.addMethod(yup.string, "email", function (errorMessage) {
    return this.test(`test-email`, errorMessage, function (value) {
      const { path, createError } = this;
      if(value == null || !value.trim()) {
        return true;
      }
      // const regex = /^\S+@\S+\.\S+$/;
      return value.length < 2 || value.length > 40 ? createError({ message: validateMessage.email }) : true;
      // const regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      // return regex.test(value) ? true : createError({ message: validateMessage.email });
    });  
  });  

  yup.addMethod(yup.string, "onlyNnumber", function (fieldName) {
    return this.test(`test-onlyNnumber`, fieldName, function (value) {
      const { path, createError } = this;
      if (value == null || value === 0 || !value.trim()) {
        return true;
      }
      const errorMessage = fieldName + ` 숫자만 입력가능합니다.`;
      const reg = /^[0-9]+$/;
      return reg.test(value) ? true : createError({ path, message: errorMessage });
    });
  });

  yup.addMethod(yup.string, "maxDigitsAndDecimals", function (intDigits, decDigits, fieldName) {
    return this.test("max-digits-and-decimals", fieldName, function (value) {
      if (value === undefined || value === null) return true;

      var decimalReg = /^[0-9]*.[0-9]*[1-9]+$/;
      var numberReg = /^[0-9]+$/;
      if (!(decimalReg.test(value) || numberReg.test(value))) {
        return this.createError({ message: fieldName + "정수 또는 소수점으로 입력가능합니다" });
      }

      const [intPart, decPart] = value.toString().split(".");
      const message =
        fieldName + ` 정수 ${intDigits}자리 소수점 ${decDigits}자리까지 입력가능합니다.`;
      if (intPart.length > intDigits) return this.createError({ message });
      if (decPart && decPart.length > decDigits) return this.createError({ message });
      return true;
    });
  });

  // valid
  const validate = async (schema: yup.Schema, obj: any, fieldMap: string[], errorfields: any[]) => {
    const result = await schema.validate(obj, { abortEarly: false }).catch((err) => {
      const errorfields = err.inner.map((row) => row.path);
      const errorMsgs = err.inner.map((row) => row.message);
      return { errors: { errorfields, errorMsgs } };
    });
    if (result["errors"] !== undefined) {
      errorfields.value = result.errors.errorfields;

      const fieldList = Object.entries(fieldMap);
      for (let errorIndex in result.errors.errorMsgs) {
        let errorMsg = result.errors.errorMsgs[errorIndex];
        for (const fieldObj of fieldList) {
          if (_.isObject(fieldObj[1])) {
            const propertyNm = fieldObj[0] + "." + Object.keys(fieldObj[1])[0];
            if (errorMsg.includes(propertyNm)) {
              result.errors.errorMsgs[errorIndex] = errorMsg.replace(
                propertyNm,
                Object.values(fieldObj[1])[0]
              );
              break;
            }
          } else {
            if (errorMsg.includes(fieldObj[0])) {
              result.errors.errorMsgs[errorIndex] = errorMsg.replace(fieldObj[0], fieldObj[1]);
              break;
            }
          }
        }
      }

      toast.warning(result.errors.errorMsgs[0]);
      return false;
      // Swal.fire({
      //   html: result.errors.errorMsgs[0],
      //   icon: "warning",
      //   confirmButtonText: "확인",
      // }).then(function () {});
      // return false;
    }
    return true;
  };

  const validateReturnMessage = async (
    schema: yup.Schema,
    obj: any,
    fieldMap: string[],
    errorfields: any[]
  ) => {
    const result = await schema.validate(obj, { abortEarly: false }).catch((err) => {
      const errorfields = err.inner.map((row) => row.path);
      const errorMsgs = err.inner.map((row) => row.message);
      return { errors: { errorfields, errorMsgs } };
    });
    if (result["errors"] !== undefined) {
      errorfields.value = result.errors.errorfields;

      const fieldList = Object.entries(fieldMap);
      for (let errorIndex in result.errors.errorMsgs) {
        let errorMsg = result.errors.errorMsgs[errorIndex];
        for (const fieldObj of fieldList) {
          if (_.isObject(fieldObj[1])) {
            const propertyNm = fieldObj[0] + "." + Object.keys(fieldObj[1])[0];
            if (errorMsg.includes(propertyNm)) {
              result.errors.errorMsgs[errorIndex] = errorMsg.replace(
                propertyNm,
                Object.values(fieldObj[1])[0]
              );
              break;
            }
          } else {
            if (errorMsg.includes(fieldObj[0])) {
              result.errors.errorMsgs[errorIndex] = errorMsg.replace(fieldObj[0], fieldObj[1]);
              break;
            }
          }
        }
      }

      // Swal.fire({
      //   html: result.errors.errorMsgs[0],
      //   icon: 'warning',
      //   confirmButtonText: '확인',
      // }).then(function () {
      // });
      return result.errors.errorMsgs[0]
      // return result.errors.errorMsgs[0];
    }
    return null;
  };

  return {
    provide: { yup: { yup, validate, validateReturnMessage } },
  };
});
